/*
 * @Author: huangzq
 * @Date: 2020-06-03 15:44:33
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-06-04 10:14:11
 * @Desc: 设置行为标签
*/
<template>
  <mk-drawer-biz-two
    :visible="visible"
    :append-to-body="true"
    :modal-append-to-body="true"
    :with-bottom="false"
    title="设置行为标签"
    size="790px"
    class="set-tag-drawer"
    v-bind="$attrs"
    @close="handelOnDrawerClose"
  >
    <div class="set-tag-tip">
      <div class="frist-tip">
        <i class="el-icon-warning"></i>
        <p>行为标签用于标注线索&客户对相关营销素材的感兴趣程度。</p>
      </div>
      <div class="second-tip">
        <p>配置行为标签后，您可以通过营销资料的打标签规则，让对应的线索&客户在访问营销资料时，打上对应标签。</p>
      </div>
    </div>

    <div class="add-tag-group">
      <mk-button-biz
        type="primary"
        icon="el-icon-plus"
        class="add-tag-btn"
        :disabled="list.length >= 20"
        @click="addTagGroupClick"
      >
        添加标签组
      </mk-button-biz>
    </div>

    <div class="tag-group-wrapper">
      <div
        v-for="(item,index) in list"
        :key="index"
        class="tag-group-item"
      >
        <div class="tag-group-item-title">
          <div class="tag-group-item-title-left">
            <p class="txt">
              {{ item.name }}
            </p>
          </div>
          <div class="tag-group-item-title-right">
            <span class="add-tag-tips">可添加标签：{{ 20 - item.children.length }}/20</span>
            <mk-button-biz
              type="text"
              class="add-tag"
              :disabled="item.children.length >= 20"
              @click="addTagClick(item)"
            >
              添加标签
            </mk-button-biz>
            <mk-button-biz
              type="text"
              class="edit-tag"
              @click="editTagGroup(item)"
            >
              编辑
            </mk-button-biz>
            <div class="switch">
              <mk-switch
                v-model="item.enable"
                class="switch-btn"
                disabled
                @click.native="toggleTag({id: item.id, enable: !item.enable}, true)"
              ></mk-switch>
              <span class="switch-txt">{{ item.enable ? '已启用': '已停用' }}</span>
            </div>
          </div>
        </div>
        <div class="tag-group-item-wrapper">
          <div
            v-if="item.children.length > 0"
            class="tag-list"
          >
            <div
              v-for="(itemB,indexB) in item.children"
              :key="indexB"
              class="tag-list-item"
            >
              <mk-popover
                placement="bottom-start"
                width="80"
                popper-class="tag-handle-management-popover"
                trigger="hover"
                :open-delay="200"
                :visible-arrow="false"
              >
                <div class="tag-handle">
                  <div
                    class="tag-handle-item tag-handle-edit"
                    @click="edit(itemB)"
                  >
                    编辑标签
                  </div>
                  <div
                    v-if="itemB.enable"
                    class="tag-handle-item"
                    @click="stopClick(itemB)"
                  >
                    停用标签
                  </div>
                  <div
                    v-if="!itemB.enable && item.enable"
                    class="tag-handle-item"
                    @click="enableClick(itemB)"
                  >
                    启用标签
                  </div>
                </div>
                <div
                  slot="reference"
                  class="tag-list-item-tag"
                  :class="itemB.enable ? 'active' : ''"
                >
                  {{ itemB.name }}
                  <mk-iconfont
                    class="edit-tag-icon"
                    icon-class="edit-tag"
                  ></mk-iconfont>
                </div>
              </mk-popover>
            </div>
          </div>
          <template v-else>
            <no-data place-holder="暂无标签" />
          </template>
        </div>
      </div>
    </div>

    <!-- 添加标签组弹窗 -->
    <add-tag-group
      v-if="showAddtagGroup"
      :tag-apis="tagApis"
      :edit-info="editGroupInfo"
      :type="tagGroupType"
      @cancel="cancelDia"
      @update="update"
    />

    <!-- 添加标签弹窗 -->
    <add-tag
      v-if="showAddtag"
      :tag-apis="tagApis"
      :edit-info="editInfo"
      :type="tagType"
      :parent-id="parentId"
      @cancel="cancelDia"
      @update="update"
    />
  </mk-drawer-biz-two>
</template>
<script>
import noData from '@components/no-data'
import addTag from './add-tag'
import addTagGroup from './add-tag-group'

export default {
  components: {
    noData,
    addTagGroup,
    addTag
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 当前组件需要的接口
    tagApis: {
      type: Object,
      default: () => {
        return {
          v1TagCompanyGet: WXTAGAPIS.TagApi.v1TagCompanyGet,
          v1TagEnablePatch: WXTAGAPIS.TagApi.v1TagEnablePatch,
          v1TagCompanyPost: WXTAGAPIS.TagApi.v1TagCompanyPost,
          v1TagNamePatch: WXTAGAPIS.TagApi.v1TagNamePatch,
          v1TagCompanyGroupPost: WXTAGAPIS.TagApi.v1TagCompanyGroupPost
        }
      }
    }
  },
  data () {
    return {
      showAddtag: false,
      showAddtagGroup: false,
      list: [],
      tagType: 'add',
      tagGroupType: 'add',
      editInfo: {},
      editGroupInfo: {},
      parentId: '' // 父级id
    }
  },
  created () {
    this.getInitTags()
  },
  methods: {
    async getInitTags () {
      const res = await this.tagApis.v1TagCompanyGet()
      if (res.success) {
        this.list = res.data
      }
    },
    update () {
      this.getInitTags()
    },
    edit (item) {
      this.tagType = 'edit'
      this.editInfo = item
      this.showAddtag = true
      this.id = item.id
      this.parentId = item.parentId
    },
    stopClick (item) {
      this.$confirm(
        '停用标签后，相关页面将不会再显示此标签，确认停用吗？',
        '停用标签',
        {
          confirmButtonText: '停用',
          cancelButtonText: '取消',
          type: 'none'
        }
      )
        .then(() => {
          this.enableTag(item.id, false)
        })
        .catch(() => {})
    },
    async enableTag (id, state) {
      // 启用
      const res = await this.tagApis.v1TagEnablePatch({
        enable: state,
        id: id
      })
      if (res.success) {
        if (state) {
          this.$message({
            type: 'success',
            message: '启用成功',
            showClose: true
          })
        } else {
          this.$message({
            type: 'success',
            message: '停用成功',
            showClose: true
          })
        }
        this.getInitTags()
      }
    },
    enableClick (item) {
      this.enableTag(item.id, true)
    },
    handelOnDrawerClose () {
      this.$emit('update:visible', false)
      this.$emit('on-close')
    },
    addTagClick (item) {
      this.showAddtag = true
      this.tagType = 'add'
      this.parentId = item.parentId
    },
    addTagGroupClick () {
      this.tagGroupType = 'add'
      this.showAddtagGroup = true
    },
    editTagGroup (item) {
      this.tagGroupType = 'edit'
      this.showAddtagGroup = true
      this.editGroupInfo = item
    },
    cancelDia () {
      this.showAddtag = false
      this.showAddtagGroup = false
    },
    // 启用停用标签
    toggleTag (params, isEditGroup) {
      if (!params.enable) {
        this.$confirm(
          '停用标签组后，相关页面将不会再显示此标签组下的所有标签，确认停用吗？',
          '',
          {
            confirmButtonText: '停用',
            cancelButtonText: '取消',
            type: 'none'
          }
        )
          .then(() => {
            this.enableTag(params.id, params.enable)
          })
          .catch(() => {})
      } else {
        this.enableTag(params.id, params.enable)
      }
    }
  }
}
</script>
<style lang="scss">
.tag-handle-management-popover {
  padding: 4px 0;
  min-width: 0;

  .tag-handle {
    .tag-handle-item {
      line-height: 37px;
      text-align: center;
      font-size: 12px;
      color: #888;
      cursor: pointer;

      &:hover {
        background: #dbf1ff;
        color: #009cff;
      }
    }
  }

  &:hover {
    .tag-list-item-tag {
      background: #dbf1ff;
      color: #009cff;
    }
  }
}
</style>
<style lang="scss" scoped>
.set-tag-drawer {
  .set-tag-tip {
    margin-bottom: 15px;
    padding: 10px;
    color: #262626;
    font-size: 14px;
    background: rgba(242, 251, 255, 1);
    border-radius: 4px;
    border: 1px solid #ccecff;
    line-height: 20px;

    .frist-tip {
      display: flex;
      align-items: center;

      .el-icon-warning {
        margin-right: 10px;
        color: #009cff;
        font-size: 16px;
      }
    }

    .second-tip {
      display: flex;
      justify-content: space-between;
      margin-left: 26px;
      color: #8c8c8c;
    }
  }

  .add-tag-group {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;

    /deep/ .add-tag-btn.el-button {
      padding: 0 14px !important;

      span {
        margin: 4px !important;
      }
    }
  }

  /deep/ .el-switch.is-disabled {
    opacity: 1;
  }

  /deep/ .el-switch.is-disabled .el-switch__core,
  /deep/ .el-switch.is-disabled .el-switch__label {
    cursor: pointer;
  }

  .tag-group-wrapper {
    overflow-y: auto;

    .tag-group-item {
      margin-bottom: 20px;
      border: 1px solid #e8e8e8;

      .tag-group-item-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 42px;
        padding: 0 20px;
        box-shadow: 0 -1px 0 0 #e8e8e8 inset;

        .tag-group-item-title-left {
          .txt {
            line-height: 15px;
            color: #595959;
            font-size: 13px;
            text-indent: 4px;
            border-left: 3px solid #009cff;
          }
        }

        .tag-group-item-title-right {
          display: flex;
          align-items: center;

          .add-tag-tips {
            color: #595959;
            font-size: 13px;
            margin-right: 30px;
          }

          .add-tag {
            margin-right: 20px;
          }

          .edit-tag {
            margin-right: 30px;
          }

          .switch {
            .switch-txt {
              font-size: 13px;
              color: #595959;
              margin-left: 12px;
            }
          }
        }
      }

      .tag-group-item-wrapper {
        padding: 20px 20px 10px 20px;

        .no-data {
          padding: 0;
        }

        .tag-list {
          display: flex;
          flex-wrap: wrap;

          .tag-list-item {
            flex: none;
            height: 28px;
            line-height: 28px;
            margin-bottom: 10px;
            margin-right: 10px;

            & > span {
              display: block;
              height: 28px;
              line-height: 28px;
            }

            .tag-list-item-tag {
              height: 28px;
              line-height: 28px;
              background-color: #f0f0f0;
              color: #c8c8c8;
              padding: 0 10px;
              border-radius: 2px;
              font-size: 12px;
              cursor: pointer;

              .edit-tag-icon {
                font-size: 12px;
                color: #c8c8c8;
                margin-left: 4px;
              }
            }

            .tag-list-item-tag.active {
              background-color: #f0f0f0;
              color: #595959;

              .edit-tag-icon {
                color: #595959;
              }
            }
          }

          // .tag-list-item:hover {
          //   .tag-list-item-tag {
          //     background-color: #dbf1ff;
          //     color: #009cff;

          //     .edit-tag-icon {
          //       color: #009cff;
          //     }
          //   }
          // }

          .tag-list-item.active:hover {
            .tag-list-item-tag {
              opacity: 1;
              background-color: #dbf1ff;
              color: #009cff;

              .edit-tag-icon {
                color: #009cff;
              }
            }
          }
        }
      }
    }
  }
}
</style>
